<div class="expansion-panel" [class.expansion-panel-opened]="opened" #panel>
  <ng-content></ng-content>
</div>